import { render } from "./BsFooterView.vue?vue&type=template&id=03859c12"
import script from "./BsFooterView.vue?vue&type=script&lang=js"
export * from "./BsFooterView.vue?vue&type=script&lang=js"

import "./BsFooterView.vue?vue&type=style&index=0&id=03859c12&lang=css"

import exportComponent from "/Users/mae/Dev/mamp/htdocs/mfj_renewal/manage/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__